import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WDialog from "@/components/wrappers/w-dialog.vue";
import WTinyMce from "@/components/wrappers/w-tiny-mce.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import DiagramEditor from "@/components/diagram/DiagramEditor.vue";
let SpeachDiagramTranslationDialog = class SpeachDiagramTranslationDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "tKey", void 0);
    _defineProperty(this, "diagramData", null);
    _defineProperty(this, "targetLangLabel", void 0);
    _defineProperty(this, "saving", void 0);
    _defineProperty(this, "visionEnabled", void 0);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "currentD2Code", '');
  }
  mounted() {
    this.chapterId = Number(this.tKey.split(".").pop() ?? NaN);
    this.currentD2Code = this.diagramData?.d2Code || '';
  }
  get shouldDisableSaveButton() {
    return this.saving || !this.currentD2Code?.length || this.diagramData?.d2Code == this.currentD2Code;
  }
  onDiagramChange(d2Code) {
    this.currentD2Code = d2Code;
  }
  onSave() {
    this.$emit('save', this.currentD2Code);
  }
  onCancel() {
    this.$emit('cancelChanges');
  }
};
__decorate([Prop({
  required: true
})], SpeachDiagramTranslationDialog.prototype, "visible", void 0);
__decorate([Prop({
  required: true
})], SpeachDiagramTranslationDialog.prototype, "tKey", void 0);
__decorate([Prop({
  required: true
})], SpeachDiagramTranslationDialog.prototype, "diagramData", void 0);
__decorate([Prop({
  default: ''
})], SpeachDiagramTranslationDialog.prototype, "targetLangLabel", void 0);
__decorate([Prop({
  default: false
})], SpeachDiagramTranslationDialog.prototype, "saving", void 0);
__decorate([Prop({
  default: false
})], SpeachDiagramTranslationDialog.prototype, "visionEnabled", void 0);
SpeachDiagramTranslationDialog = __decorate([Component({
  components: {
    DiagramEditor,
    WDialog,
    WTinyMce,
    StandardButton
  },
  emits: ["save", "cancelChanges"]
})], SpeachDiagramTranslationDialog);
export default SpeachDiagramTranslationDialog;